import React, { memo } from 'react';
import { CircularProgress } from '@mui/material';
import styles from './SignupButtons.module.css';

const BtnPrimary = ({ text, onClick, customClassName, loading, disabledBtn, error, errorMsg }) => {
    return (
        <div className={`${styles.btnWrapper} ${customClassName} `}>
            <button
                className={`${styles.button} ${styles.flex} ${disabledBtn && styles.disabled}`}
                onClick={onClick}
                disabled={disabledBtn}
            >
                {!loading && <span>{text}</span>}
                {
                    loading && <CircularProgress size={"22px"}
                        thickness={6}
                        variant="indeterminate"
                        disableShrink
                        sx={{
                            color: "#fff",
                            // marginTop: "4px",
                            animationDuration: '450ms',
                        }} />
                }
            </button>
            {
                error &&
                <p className={styles.errorMsg}>{errorMsg}</p>
            }</div>
    );
};

export default memo(BtnPrimary);
